import React, { useEffect, useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { UserIcon, StoreIcon, CreditCardIcon, PackageIcon, BellIcon, ShieldIcon, HelpCircleIcon, SettingsIcon, ChevronRightIcon } from 'lucide-react';
export const AccountSettingsLayout = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  // Determine which nav item is active based on the current path
  const isActive = (path: string) => {
    return location.pathname.includes(path);
  };
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-3171">
      <Navbar scrolled={scrolled} data-id="element-3172" />
      <main className="pt-24 pb-20" data-id="element-3173">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3174">
          <div className="max-w-7xl mx-auto" data-id="element-3175">
            <div className="mb-8" data-id="element-3176">
              <h1 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-3177">
                Account Settings
              </h1>
              <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-3178">
                Manage your account preferences and profile information
              </p>
            </div>
            <div className="flex flex-col md:flex-row gap-8" data-id="element-3179">
              {/* Left Sidebar Navigation */}
              <div className="w-full md:w-64 shrink-0" data-id="element-3180">
                <div className="bg-white dark:bg-[#162825] rounded-xl shadow-sm sticky top-24" data-id="element-3181">
                  <nav className="py-2" data-id="element-3182">
                    <ul className="space-y-1" data-id="element-3183">
                      <li data-id="element-3184">
                        <Link to="/account-settings/profile" className={`flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md ${isActive('profile') ? 'bg-[#2DB489]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-3185">
                          <div className="flex items-center" data-id="element-3186">
                            <UserIcon className="w-4 h-4 mr-3" data-id="element-3187" />
                            <span data-id="element-3188">Your Profile</span>
                          </div>
                          <ChevronRightIcon className="w-4 h-4" data-id="element-3189" />
                        </Link>
                      </li>
                      <li data-id="element-3190">
                        <Link to="/account-settings/notifications" className={`flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md ${isActive('notifications') ? 'bg-[#2DB489]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-3191">
                          <div className="flex items-center" data-id="element-3192">
                            <BellIcon className="w-4 h-4 mr-3" data-id="element-3193" />
                            <span data-id="element-3194">Notifications</span>
                          </div>
                          <ChevronRightIcon className="w-4 h-4" data-id="element-3195" />
                        </Link>
                      </li>
                      <li data-id="element-3196">
                        <Link to="/account-settings/security" className={`flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md ${isActive('security') ? 'bg-[#2DB489]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-3197">
                          <div className="flex items-center" data-id="element-3198">
                            <ShieldIcon className="w-4 h-4 mr-3" data-id="element-3199" />
                            <span data-id="element-3200">Security</span>
                          </div>
                          <ChevronRightIcon className="w-4 h-4" data-id="element-3201" />
                        </Link>
                      </li>
                      <li data-id="element-3202">
                        <Link to="/account-settings/support" className={`flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md ${isActive('support') ? 'bg-[#2DB489]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-3203">
                          <div className="flex items-center" data-id="element-3204">
                            <HelpCircleIcon className="w-4 h-4 mr-3" data-id="element-3205" />
                            <span data-id="element-3206">Support & Feedback</span>
                          </div>
                          <ChevronRightIcon className="w-4 h-4" data-id="element-3207" />
                        </Link>
                      </li>
                      <li data-id="element-3208">
                        <Link to="/account-settings/actions" className={`flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md ${isActive('actions') ? 'bg-[#2DB489]/10 text-[#2DB489] dark:text-[#4ED1A0]' : 'text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-50 dark:hover:bg-[#1A3330]'}`} data-id="element-3209">
                          <div className="flex items-center" data-id="element-3210">
                            <SettingsIcon className="w-4 h-4 mr-3" data-id="element-3211" />
                            <span data-id="element-3212">Account Actions</span>
                          </div>
                          <ChevronRightIcon className="w-4 h-4" data-id="element-3213" />
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              {/* Right Content Area */}
              <div className="flex-1" data-id="element-3214">
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 md:p-8 shadow-sm" data-id="element-3215">
                  <Outlet data-id="element-3216" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-3217" />
    </div>;
};